// src/components/layout/ScrollToTop.jsx
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const [isScrolling, setIsScrolling] = useState(false);

  useEffect(() => {
    // Only scroll for main content changes, not for query params
    const cleanPathname = pathname.split('?')[0];
    
    const scrollToTop = () => {
      setIsScrolling(true);
      
      const startPosition = window.pageYOffset;
      const targetPosition = 0;
      const distance = targetPosition - startPosition;
      const duration = 500; // ms
      let startTime = null;
      
      const animation = (currentTime) => {
        if (startTime === null) startTime = currentTime;
        const timeElapsed = currentTime - startTime;
        const progress = Math.min(timeElapsed / duration, 1);
        
        // Easing function for smooth scroll
        const ease = (t) => t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        const easeProgress = ease(progress);
        
        window.scrollTo(0, startPosition + distance * easeProgress);
        
        if (timeElapsed < duration) {
          requestAnimationFrame(animation);
        } else {
          setIsScrolling(false);
        }
      };
      
      requestAnimationFrame(animation);
    };
    
    scrollToTop();
  }, [pathname]);

  // Optional: Show scroll progress indicator
  useEffect(() => {
    const handleScroll = () => {
      if (!isScrolling) {
        // Update scroll indicator if needed
      }
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isScrolling]);

  return null;
};

export default ScrollToTop;